import axios from "axios"

// Interceptor para agregar el token antes de cada solicitud
axios.interceptors.request.use(async (config) => {

  const community = localStorage.getItem('token');
  const tokensStorage = JSON.parse(localStorage.getItem('token-gestion'));
  const path = window.location.pathname;
  const match = path.match(/\/dashboard\/(\d+)(\/|$)/);

  if (community) {
    config.headers['Authorization'] = `Bearer ${community}`;
  }
  if ((tokensStorage && match && match[1]) || (config.customData || {}).idMoment) {
    const id = (match || [])[1] || (config.customData || {}).idMoment;
    config.headers['X-Authorization-2'] = `Bearer ${tokensStorage[id]}`;
  }

  return config;
},(error) => {
  // Manejo de errores antes de enviar la solicitud
  return Promise.reject(error);
});

axios.defaults.headers.common['Content-Type'] = 'application/json; charset=utf-8';
axios.defaults.baseURL = process.env.VUE_APP_URL_API || 'http://localhost:3000';

export default axios;
